import { FC } from "react";

import { Button, makeStyles, tokens } from "@fluentui/react-components";

import { ThreadData } from "../constants/threads";

interface ThreadsListProps {
  activeThreadId?: string;
  threads?: ThreadData[];
  onClose: () => void;
  onThreadSelect?: (threadId: string) => void;
}

export const ThreadsList: FC<ThreadsListProps> = ({
  activeThreadId,
  onClose,
  onThreadSelect,
  threads = [],
}) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      {threads.map((thread) => (
        <Button
          appearance="transparent"
          className={styles.threadItem}
          key={thread.uuid}
          onClick={() => {
            if (onThreadSelect) {
              onThreadSelect(thread.uuid);
            }
            onClose();
          }}
        >
          {activeThreadId === thread.uuid && (
            <div className={styles.activeThreadIndicator} />
          )}
          <div className={styles.threadContent}>
            <div className={styles.threadTitle}>
              {thread.title || "Untilted thread"}
            </div>
          </div>
        </Button>
      ))}
    </div>
  );
};

const useStyles = makeStyles({
  activeThreadIndicator: {
    backgroundColor: tokens.colorBrandBackground,
    borderRadius: "2px",
    height: "60%",
    left: "0px",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: "3px",
  },
  container: {
    maxHeight: "72dvh",
    overflowY: "auto",
  },
  sectionTitle: {
    color: "#6B7280",
    fontSize: "12px",
    fontWeight: "600",
    letterSpacing: "0.05em",
    margin: "0",
    padding: "8px 8px 4px 8px",
    textTransform: "uppercase",
  },
  threadContent: {
    flex: "1",
    minWidth: "0",
  },
  threadItem: {
    "&:hover": {
      backgroundColor: tokens.colorSubtleBackgroundHover,
    },
    alignItems: "center",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    display: "flex",
    gap: "12px",
    margin: "2px 8px 2px 0",
    padding: "4px 8px 4px 10px",
    position: "relative",
    textAlign: "left",
    width: "100%",
  },
  threadTime: {
    color: "#9CA3AF",
    flexShrink: "0",
    fontSize: "11px",
  },
  threadTitle: {
    color: tokens.colorNeutralForeground1,
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "2px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
